import React, { useState, useEffect, useCallback, useContext } from "react";
import "./AccessCodeRegister.scss";
import { Button, RedeemCodeInput, IESAuthUtilV2 } from "@activehub/common-components-spa-resource";
import { getAccessCodeData } from '../../network/ApiService';
import { Loader } from "../loader/Loader";
import { useHistory } from 'react-router-dom';
import { IESConfig, IESOptions } from '../../constants/IESConfig';

const AccessCode = (props) => {
  const history = useHistory();
  const [iesSession, setIesSession] = useState(null);
  const [accessCode, setAccessCode] = useState('')
  const [isError, setIsError] = useState(false)
  const [isCodeValid, setIsCodeValid] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')
  const [toolTip, setToolTip] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [ebookTitle, setEbookTitle] = useState('')
  const [btnClicked, setBtnClicked] = useState(false);
  const [isbtnDisabled, setIsbtnDisabled] = useState(false);

  const HTMLEntities = require('html-entities');
  
  const Entities = ('AllHtmlEntities' in HTMLEntities) ? HTMLEntities.AllHtmlEntities : function () {
    this.encode = HTMLEntities.encode;
    this.decode = HTMLEntities.decode;
    this.decodeEntity = HTMLEntities.decodeEntity;
  
    return this;
  }
  const entities = new Entities();

  let handleOutSideClick = useCallback((e) => {
    if (!e?.target.className.includes('form-control form__input')) {
      const codeInputValue = document.querySelector('.redeem-code-input .form__input')?.value || "";
      if(codeInputValue !== "" && codeInputValue.length < 35){
        setIsError(true);
        setIsCodeValid(false);
        setToolTip(false);
        setErrorMsg("This code is not valid. Please enter a different code.");
      }
    }
    if (!e?.target.className.includes('next-step')) {
      setToolTip(false);
    }
  }, []);

  useEffect(function () {
    let currentElement = document?.activeElement;
    let timerId = null;
    timerId = setTimeout(function () {
      if (currentElement) {
        document.addEventListener('click', handleOutSideClick);
      }
    }, 0);
    return function () {
      clearTimeout(timerId);
      document.removeEventListener('click', handleOutSideClick);
    };
  }, [handleOutSideClick]);

  useEffect(()=>{
    // Set access code if it exists, regardless of ebook title
    if(props?.accessCode){
      setAccessCode(props?.accessCode)
      setIsError(false);
      setErrorMsg("");
      setIsCodeValid(true);
      // Set ebook title if provided, otherwise keep existing or empty
      if(props?.ebookTitle){
        setEbookTitle(props?.ebookTitle)
      }
    }
  }, [props?.accessCode, props?.ebookTitle])

    useEffect(() => {
        const userIdKey = Object.keys(localStorage).find(key => key.includes('PiUserId'))
        const successUrl = window.location.href.includes('/login') ? window.location.href.split("#")[0] : window.location.href;
        if (localStorage.getItem(userIdKey)) {
            window.location.assign(successUrl);
        }

        const loginTypeVal = sessionStorage.getItem("LOGINTYPE");
        const loginParams = (loginTypeVal) ? { queryParams: { loginType: loginTypeVal } } : {};
        const iesSubscription = IESAuthUtilV2.load({
            ...IESConfig,
            callbackURL: window.location.origin,
            domain: window.location.hostname,
            ...loginParams
        }, IESOptions).subscribe((session) => {
            console.count("IES Session")
            setIesSession(session);
        });

        return () => iesSubscription.unsubscribe();
    }, []);

  const handleCodeChange = (e) => {
    const value = e?.target?.value || '';
    setAccessCode(value);
    setToolTip(false);
    if (value == '') {
      setIsError(false);
      setIsCodeValid(false);
      setIsbtnDisabled(false);
      setErrorMsg("");
    }
    else {
      regexValidation(value)
    }
  };

  const setClient = (e) => {
    sessionStorage.setItem("LOGINTYPE", e.target.id)
    iesSession.login();
  }

    const setValidationStatus = (status) => {
      if(status == 'UNREDEEMED'){
          setIsError(false);
          setErrorMsg("");
          setIsCodeValid(true);
          setIsbtnDisabled(false);
        }
        else if(status == 'EXPIRED'){
          setIsError(true);
          setIsCodeValid(false);
          setErrorMsg("This code is expired");
        }else if (status == 'REDEEMED') {
          setIsError(true);
          setIsCodeValid(false);
          setErrorMsg("This code has already been activated. Please enter a new code.");
        }
        else if (status == 'INACTIVE') {
          setIsError(true);
          setIsCodeValid(false);
          setErrorMsg("This code is inactive");
        }
  }

  const regexValidation = (value) => {
    const Ahregex = /^(?:\d{6}-[A-Z]{5}(?:-[A-Z]{5}){4}|[A-Z0-9]{8}-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{11}|[A-Z]{5}(?:-[A-Z]{5}){5})$/;
     if(value !== '' && value.length < 35){ 
     setIsError(false);
      setErrorMsg("");
    }else if(value !=='' && value.length >= 35 && !Ahregex.test(value) || btnClicked){
      setIsError(true);
      setIsCodeValid(false);
      setErrorMsg("This code is not valid. Please enter a valid code");
    }
    else if (value && Ahregex.test(value)) {
      setTimeout(() => {
        setIsLoading(true);
        setIsbtnDisabled(true);
        getAccessCodeData(value).subscribe(
          (response) => {
            setEbookTitle(response?.resourceTitle);
            setIsLoading(false);
            setIsbtnDisabled(true);
            setValidationStatus(response?.status);
            setIsLoading(false);
          },
          (error) => {
            setIsError(true);
            setIsCodeValid(false);
            setIsLoading(false);
            if (error?.data?.status == 404 && (error?.data?.detail =='Accesscode not found' || error?.data?.detail =='No product found for the given isbn')) {
              setErrorMsg("This code is not valid. Please enter a different code.");
            }else if (error?.data?.status == 404 && error?.data?.detail !=='No product found for the given isbn') {
              setErrorMsg(error?.data?.detail || "This code is not valid. Please enter a different code.");
            }else if (error?.data?.status == 404 && error?.data?.detail =='No product found for the given isbn'){
              setValidationStatus(error?.data?.accessCodeStatus);
              setEbookTitle("");
            }else {
              setErrorMsg(error?.data?.detail);
            }
          }
        );
    }, 300)
    }
    else {
      setIsError(false);
      setErrorMsg("This code is not valid. Please enter a valid code.");
      setIsCodeValid(false);
    }
  }

  const validateAccessCode = () => {
    setBtnClicked(false);
    if(accessCode==''){
      setIsError(true);
      setIsCodeValid(false);
      setErrorMsg("Please enter an access code");
    }
    else {
      regexValidation(accessCode);
    }
  }

  const handleNext = () => {
    setBtnClicked(true);
    if(!isCodeValid){
      validateAccessCode();
      setToolTip(true);
    }
    else {
      props.onNextStep(accessCode, ebookTitle);
    }
  };

  return(<>{isLoading && <Loader />}<div className="access-code new-user-access-code-register">
    <h4>Enter your access code</h4>
    <RedeemCodeInput
      inputtype={"text"}
      // title={"Access code"}
      // name={accessCode}
      value={accessCode}
      labelClassName="titleAfter"
      onChange={handleCodeChange}
      // onBlur={validateAccessCode}
      customDataAttributes={{
        "aria-required": true,
        "maxLength": 38
      }}
      isError={isError}
      isValidCode ={isCodeValid}
      errorMsg={errorMsg}
      required={true}
      showClearIcon={isError}
      preventAction={toolTip}
      showTooltip={toolTip}
    />
    {(isCodeValid && ebookTitle) && <div className="ebook-title">{entities?.decode(ebookTitle)}</div>}

    <Button className="next-step" tabIndex={true ? 0 : -1} isDisabled={isError || isbtnDisabled} onClick={handleNext}>
      Next Step <img src={`${process.env.PUBLIC_URL}/images/greater-${isError ?`grey`:`white`}-icon.svg`} width="10" height="10" alt="img" />
    </Button>
    <Button className="access-code-sign-in" tabIndex={true ? 0 : -1} onClick={setClient} >
      Already have an account? Sign in
    </Button>
  </div></>)
}

export default AccessCode;
